module.exports = __webpack_public_path__ + "static/img/img_intro_wx.ff9df36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_intro_wx.png
// module id = kYV/
// module chunks = 1